<script setup lang="ts">

</script>

<template>
  <header>
    <video autoplay muted loop playsinline>
      <source src="../assets/test.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div class="content">
      <h1>
        Ervaar je hartslag
        <img src="@/assets/images/g8.png" alt="hartstichting logo" class="logo">
      </h1>
      <h2>Maak het met ons mee!</h2>
    </div>
  </header>
</template>

<style scoped>
h1 {
  font-size: 4rem;
}

.logo {
  height: 4rem;
}

header {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

header video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1;
  transform: translate(-50%, -50%);
  object-fit: cover;
  pointer-events: none;

  /* Add filters here */
  filter: var(--filter-dimmed);
}

header .content {
  position: relative;
  z-index: 1;
  color: white;
  text-align: center;
  padding-top: 30vh;
}
</style>